import classNames from 'classnames'
import React, { useState } from 'react'
import classes from './expenseFilter.module.css'

function ExpenseFilter({ months }) {
  const [ selectedMonth, setSelectedMonth ] = useState(months[0])

  const handleMonthClick = (month) => {
    setSelectedMonth(month)
  }

  return (
    <div className={classes.expensesFilter}>
      <div className={classes.selectWrapper}>
        <select name="slct" className={classes.select}>
          <option selected>Monthly</option>
          <option value="1">Yearly</option>
        </select>
      </div>
      <div className={classes.monthsWrapper}>
        {months.map((month) => (
          <div
            className={classNames(classes.month, { [classes.month_active]: month === selectedMonth })}
            role="button"
            tabIndex={0}
            onKeyPress={() => handleMonthClick(month)}
            onClick={() => handleMonthClick(month)}
            key={month}
          >
            {month.toLowerCase()}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ExpenseFilter
